exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h3[data-v-bfc79b80]{margin-top:1rem}p[data-v-bfc79b80]{font-size:small;letter-spacing:normal;line-height:1.2rem!important;text-align:justify}.coords-container[data-v-bfc79b80]{display:flex;align-items:center;justify-content:left}.coords-text[data-v-bfc79b80]{margin-left:.5rem;font-size:x-small;font-weight:700;opacity:.75}", ""]);

// exports
